'use client';

import HomeHero from "@/components/HomeHero/HomeHero";
import WhatIsPFDN from "@/components/WhatIsPFDN/WhatIsPFDN";
import WhoIsThisFor from "@/components/WhoIsThisFor/WhoIsThisFor";

export default function HomeClient() {
  return (
    <main id="main-content">
      <HomeHero />
      <WhatIsPFDN />
      <WhoIsThisFor />
    </main>
  );
}
